import { Smartphone, Monitor, Apple } from "lucide-react";
import { Button } from "@/components/ui/button";

export const MobileAppPrompt = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 py-12 text-center">
      <div className="max-w-md space-y-8">
        <div className="space-y-4">
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <Smartphone className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold text-foreground">
            This website is meant for Desktop
          </h1>
          <p className="text-muted-foreground leading-relaxed">
            For the best mobile experience, please download our app. Global Chat Connect breaks language barriers instantly. Chat in real-time with anyone, anywhere, with automatic translation of every message.
          </p>
        </div>

        <div className="space-y-4">
          <a
            href="https://apps.apple.com/us/app/global-chat-connect/id6755732689"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <Button className="w-full gap-2" size="lg">
              <Apple className="w-5 h-5" />
              Download for iOS
            </Button>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=app.lovable.c16458328a2848af9115a825783212c2&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <Button variant="outline" className="w-full gap-2" size="lg">
              Download for Android
            </Button>
          </a>
        </div>

        <div className="pt-4 border-t border-border">
          <a
            href="https://globalchatconnect.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-primary hover:underline"
          >
            <Monitor className="w-4 h-4" />
            Open Desktop Version
          </a>
        </div>
      </div>
    </div>
  );
};
